import { render, staticRenderFns } from "./FormularioCarnaval.vue?vue&type=template&id=13c03e61&scoped=true&"
import script from "./FormularioCarnaval.vue?vue&type=script&lang=ts&"
export * from "./FormularioCarnaval.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioCarnaval.vue?vue&type=style&index=0&id=13c03e61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c03e61",
  null
  
)

export default component.exports